module.exports = __webpack_public_path__ + "static/media/diamond.1dc11e95.png";